





























































































import { AnchorType, DocumentAnchor } from "@infoland/iprova-api";
import Vue from "vue";
import storeHelper from "../../store/store-helper";
import ZenyaDialog, { ZenyaDialogComponent, ZenyaDialogInjects } from "../dialogs/ZenyaDialog.vue";
import DocumentComments from "../dialogs/DocumentComments.vue";
import { Comment, loadDocumentCommentsAsync } from "@/documentComments";
import { CommentState, CommentType, DirectedAt, SnackBarTimeout } from "@/enums";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "CommentDialog",
    props: {
        isInteractiveDocument: Boolean,
        isStructuredDocument: Boolean,
        documentId: String,
        version: Number,
        commentSubjectSelections: Array,
        commentType: String as () => CommentType,
        userIsDocumentAdministrator: Boolean,
        showCommentsList: Boolean
    },
    data: function () {
        return {
            commentText: "",
            commentSubjectCurrentSelection: null as DocumentAnchor,
            commentSubjectText: "",
            customName: "",
            customPhoneNumber: "",
            customEmailAddress: "",
            previousComments: [] as Comment[],
            showPreviousCommentsDialog: false as boolean,
            selectedDirectedAt: null as DirectedAt,
            directedAt: { ...DirectedAt }
        };
    },
    components: { ZenyaDialog, DocumentComments },
    computed: {
        requiredRules() {
            return [v => !!v || this.$t("general.validation.isRequired")];
        },
        isReaderComment(): boolean {
            return this.commentType === CommentType.Reader;
        },
        isReviewerComment(): boolean {
            return this.commentType === CommentType.Reviewer;
        },
        requiresUserData(): boolean {
            return this.isReaderComment && (this.isAnonymousUSer || this.$user.account_type == "group");
        },
        isAnonymousUSer(): boolean {
            return this.$user.user_type == "system_user" && this.$user.login_code == "Anonymous";
        }
    },
    async created() {
        //register handler for dialog OK button
        this.registerHandlers({ ok: this.addCommentAsync, cancel: this.resetInputAsync });
    },
    watch: {
        commentSubjectSelections: function () {
            if (this.commentSubjectSelections) {
                // Select the first subject
                this.commentSubjectCurrentSelection =
                    this.commentSubjectSelections.length > 0 ? (this.commentSubjectSelections[0] as DocumentAnchor) : null;
            }
        },
        documentId: {
            handler() {
                if (this.showCommentsList) {
                    this.resetInputAsync();
                    this.loadPreviousCommentsAsync();
                }
            },
            immediate: true
        }
    },
    methods: {
        validateForm() {
            const formIsValid = (this.$refs.commentForm as Vue & { validate: () => boolean }).validate();

            return formIsValid;
        },
        async loadPreviousCommentsAsync(): Promise<void> {
            const urlPath = `documents/${this.documentId}/v${this.version}/comments/`;
            this.previousComments = (await loadDocumentCommentsAsync(urlPath)).sort(function (a: Comment, b: Comment) {
                return b.created_datetime.getTime() - a.created_datetime.getTime();
            });
        },
        async addCommentAsync(): Promise<boolean> {
            if (this.validateForm()) {
                if (!this.commentText.trim() || this.commentText.length > 500)
                    //Return if comment is empty or longer then the max length
                    return false;

                //Set subject info
                let anchorId: string;
                let anchorType: AnchorType;
                let anchorText: string;

                if ((this.isInteractiveDocument || this.isStructuredDocument) && this.commentSubjectCurrentSelection) {
                    anchorId = this.commentSubjectCurrentSelection.id;
                    anchorText = this.commentSubjectCurrentSelection.text;
                    anchorType = this.commentSubjectCurrentSelection.type;
                } else {
                    anchorId = null;
                    anchorText = this.commentSubjectText;
                    anchorType = AnchorType.document;
                }

                //Post comment
                const comment: Partial<Comment> = {
                    text: this.commentText,
                    anchor_id: anchorId,
                    anchor_text: anchorText,
                    anchor_type: anchorType,
                    state: CommentState.New,
                    directed_at: this.selectedDirectedAt,
                    type: this.commentType
                };
                if (this.requiresUserData) {
                    comment.creator_name = this.customName;
                    comment.creator_telephone = this.customPhoneNumber ? this.customPhoneNumber : "";
                    comment.creator_email = this.customEmailAddress ? this.customEmailAddress : "";
                }

                let result = await storeHelper.documentStore.addCommentAsync(comment as Comment, this.documentId, this.version);
                await this.resetInputAsync();
                //Check if comment posted successfully
                if (result) {
                    // showCommentsList is true when the right comments panel is not used,
                    //and we need this confirmation message in order to know that the comment was added
                    if (this.showCommentsList) {
                        storeHelper.siteStore.setSnackBarMessage(
                            this.$t("comment.commentSuccesfullMessage").toString(),
                            false,
                            SnackBarTimeout.extra_long
                        );
                    }
                    return true;
                } else return false;
            }
        },

        async resetInputAsync(): Promise<boolean> {
            //Resets the subject selection
            if (this.commentSubjectSelections) {
                this.commentSubjectCurrentSelection =
                    this.commentSubjectSelections.length > 0 ? (this.commentSubjectSelections[0] as DocumentAnchor) : null;
            }
            if (this.commentSubjectText) {
                this.commentSubjectText = null;
            }
            if (this.commentText) {
                this.commentText = null;
            }
            this.customName = null;
            this.customPhoneNumber = null;
            this.customEmailAddress = null;

            return true;
        }
    }
});
